import { z } from "zod";

import { ImageEntity } from "~/entities/image/model";
import { Response } from "~/shared/api";

const zOutSchema = ImageEntity.zSchema
  .pick({
    id: true,
  })
  .extend({
    fileName: ImageEntity.zSchema.shape.fileName.nullable(),
    contentType: ImageEntity.zSchema.shape.contentType.nullable(),
    uploadedAt: z.string().datetime(),
  });
type OutSchema = z.infer<typeof zOutSchema>;

const zRes401 = Response.Schema.zNoBody(401);

export { zOutSchema, zRes401 };
export type { OutSchema };
